<template>
  <div class="Home">
    <div style="height: 100px"></div>
    <div class="content-wrapper">
      <div>
        <button class="tab-button active" id="ITInfrastructure" v-on:click="showTab('ITInfrastructure')">
          企业IT基础架构
        </button>
        <button class="tab-button" id="customization" v-on:click="showTab('customization')">
          定制化解决方案
        </button>
        <button class="tab-button" id="ProcessAutomation" v-on:click="showTab('ProcessAutomation')">
          智能数据与流程自动化
        </button>
        <button class="tab-button" id="ITO" v-on:click="showTab('ITO')">
          ITO资源外包
        </button>
      </div>
      <!-- 标签内容 -->
      <div id="ITInfrastructureTab" class="tab-content">
        <img src="../../resources/images/ITInfrastructure/13.png" alt="IT基础架构">
        <img src="../../resources/images/ITInfrastructure/14.png" alt="IT基础架构">
        <img src="../../resources/images/ITInfrastructure/15.png" alt="IT基础架构">
        <img src="../../resources/images/ITInfrastructure/16.png" alt="IT基础架构">
        <img src="../../resources/images/ITInfrastructure/17.png" alt="IT基础架构">
      </div>

      <div id="customizationTab" class="tab-content" style="display: none">
        <img src="../../resources/images/customization/18.png" alt="定制化解决方案">
        <img src="../../resources/images/customization/19.png" alt="定制化解决方案">
        <img src="../../resources/images/customization/20.png" alt="定制化解决方案">
        <img src="../../resources/images/customization/21.png" alt="定制化解决方案">
        <img src="../../resources/images/customization/22.png" alt="定制化解决方案">
      </div>

      <div id="ProcessAutomationTab" class="tab-content" style="display: none">
        <img src="../../resources/images/ProcessAutomation/23.png" alt="智能数据与流程自动化">
        <img src="../../resources/images/ProcessAutomation/24.png" alt="智能数据与流程自动化">
        <img src="../../resources/images/ProcessAutomation/25.png" alt="智能数据与流程自动化">
        <img src="../../resources/images/ProcessAutomation/26.png" alt="智能数据与流程自动化">
        <!--<img src="../../resources/images/ProcessAutomation/27.png" alt="智能数据与流程自动化">!-->
        <img src="../../resources/images/ProcessAutomation/28.png" alt="智能数据与流程自动化">
      </div>

      <div id="ITOTab" class="tab-content" style="display: none">
        <img src="../../resources/images/ITO/29.png" alt="ITO资源外包">
        <img src="../../resources/images/ITO/30.png" alt="ITO资源外包">
        <img src="../../resources/images/ITO/31.png" alt="ITO资源外包">
        <img src="../../resources/images/ITO/32.png" alt="ITO资源外包">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "solution",
  components: {},
  methods: {
    showTab(tabName){
        // 获取所有标签内容并隐藏它们
        var tabContent = document.getElementsByClassName("tab-content");
        for (var i = 0; i < tabContent.length; i++) {
            tabContent[i].style.display = "none";
        }

        // 获取所有标签按钮并删除它们的活动类
        var tabButton = document.getElementsByClassName("tab-button");
        for (var i = 0; i < tabButton.length; i++) {
            tabButton[i].classList.remove('active')
        }

        // 显示当前选定的标签并添加活动类到选定的按钮
        document.getElementById(tabName+"Tab").style.display = "block";
        document.getElementById(tabName).classList.add('active')
    }
  },
  mounted: function () {
    const hash = this.$route.hash;
    console.log(hash);
    if (hash)
        this.showTab(hash.substring(1));
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/home/Solution.vue